import React from "react";
import Timer from "./Timer";
import {getStatus, getStatusColor} from "../../../utils/utils"
import { CircularProgress } from '@material-ui/core';

function TimeCounter (props) {

    const totalSeconds = props.remainingSeconds

    if (totalSeconds > 0){
        let remaining_minutes = Math.floor(totalSeconds/60)
        let remaining_seconds = totalSeconds%60
        return (
            <div className="analysisCard">
                <div style={{margin: "auto",display: "flex"}}>
                    <Timer manual_analysis_limit={props.reservation.manual_analysis_limit_date} time={{minutes: remaining_minutes, seconds: remaining_seconds}}/>
                </div>
            </div>
        ) 
    }
    else if (totalSeconds != null){
        return (
            <div className="analysisCard" style={{height:"100%", borderWidth:"1px", borderStyle:"solid", borderColor:getStatusColor("analysis_time_expired")}}>
                <div 
                    className={["normalText, substitleSize", "bold"].join(" ")} 
                    style={{margin:"auto", color:getStatusColor("analysis_time_expired")}}
                >
                    {getStatus("analysis_time_expired")}                    
                </div>
            </div>
        ) 
    }
    else {
        return (
            <div className="analysisCard" style={{height:"100%"}}>
                <div style={{margin: "auto"}}>
                    <CircularProgress />
                </div>
            </div>
        )
    }
}

export default TimeCounter;
